import { render, staticRenderFns } from "./PrivilegeRecalculationArchive.vue?vue&type=template&id=58f5413b&scoped=true&"
import script from "./PrivilegeRecalculationArchive.vue?vue&type=script&lang=js&"
export * from "./PrivilegeRecalculationArchive.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeRecalculationArchive.vue?vue&type=style&index=0&id=58f5413b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f5413b",
  null
  
)

export default component.exports